import axios from './axiosInstances/axiosInstance';

export const retrieveBasketAppliedRewards = (basketId, printedCardNumber) => {
  return axios.get(`baskets/${basketId}/loyaltyrewards?printedCardNumber=${printedCardNumber}`);
};
